<template>
  <section class="app-main">
    <div class="top-bar">
      <el-date-picker
        v-model="fixDate"
        @change="handleDate"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        style="width: 240px; margin-right: 15px"
      ></el-date-picker>
      <el-input
        placeholder="输入用户名称或者手机号"
        v-model="value"
        @change="search"
        style="width: 200px; margin-right: 25px"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <div style="margin-top: 10px">
        <el-tag type="danger" style="margin-right: 10px"
          >总计平台用户：{{ totalUsers }}</el-tag
        >
        <el-tag type="danger" style="margin-right: 10px"
          >登录平台用户：{{ loginUsers }}</el-tag
        >
        <el-tag type="danger">当前平台用户：{{ currentUsers }}</el-tag>
      </div>
      <!-- <el-button  class="top-btn" type="primary" plain @click="handleBatch(1)">群发短信</el-button>
            <el-button  class="top-btn" type="success" plain @click="handleBatch(2)">群发邮件</el-button> -->
    </div>
    <el-card shadow="hover">
      <el-table
        :data="tableData"
        @selection-change="handleChecked"
        empty-text="暂无用户"
        height="560"
      >
        <el-table-column type="selection" width="100" align="center">
        </el-table-column>
        <el-table-column prop="username" label="用户账号" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="nickname" label="昵称" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="realname" label="姓名" align="center">
        </el-table-column>
        <el-table-column prop="sex_title" label="性别" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="手机号" align="center">
        </el-table-column>
        <el-table-column prop="email" label="邮箱" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="is_guest" label="账号性质" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.is_guest == 0">平台账户</span>
            <span v-if="scope.row.is_guest == 1">游客账户</span>
          </template>
        </el-table-column>
        <el-table-column prop="wx_openid wx_unionid" label="是否绑定微信" align="center" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.wx_openid == null || scope.row.wx_openid == '' || scope.row.wx_unionid == null || scope.row.wx_unionid == '' ? '未绑定' : '已绑定'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="login_time" label="登录时间" align="center">
        </el-table-column>
        <el-table-column prop="created_at" label="注册时间" align="center">
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="reloadData"
        layout="prev, pager, next, jumper"
        style="padding: 15px"
        :total="total"
        :page-size="size"
      ></el-pagination>
    </el-card>
  </section>
</template>


<script>
import { member, roles_add, roles_put, roles_del } from "@/api/platform.js";

export default {
  name: "UserList",
  data() {
    return {
      value: "",
      tableData: [],
      page: 1,
      size: 20,
      total: 0,
      dialog: false, // 控制显示 添加修改弹窗
      ids: [], // table 选中数据的 id 数组集合
      fixDate: [],
      totalUsers: 0,
      loginUsers: 0,
      currentUsers: 0,
    };
  },
  methods: {
    // 搜索会员
    search() {
      this.page = 1;
      this.handleData();
    },

    // 日期查询搜索
    handleDate() {
      this.page = 1;
      this.handleData();
    },
    // 获取会员数据
    handleData() {
      let params = {
        page: this.page,
      };
      if (this.value != "") {
        params.search = this.value;
      }

      if (this.fixDate && this.fixDate.length != 0) {
        params.start_date_search = this.fixDate[0];
        params.end_date_search = this.fixDate[1];
      }

      member(params).then((res) => {
        if (res) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.size = res.data.per_page;
          this.totalUsers = res.total_users;
          this.loginUsers = res.login_users;
          this.currentUsers = res.current_users;
        } else {
          this.tableData = [];
          this.loginUsers = 0;
          this.currentUsers = 0;
        }
      });
    },
    reloadData(page) {
      this.page = page;
      this.handleData();
    },

    // 显示添加修改弹窗
    handleShow(row) {
      if (row) {
        this.dialog = true;
        this.dialogTitle = "修改栏目";
        this.id = row.role_id;
        this.title = row.title;
        this.describe = row.describe;
        this.status = row.status;
        this.marks = row.permission.split(",");
      } else {
        this.dialog = true;
        this.dialogTitle = "添加栏目";
        this.id = "";
        this.title = "";
        this.describe = "";
        this.status = 1;
        this.marks = [];
      }
    },
    // 弹窗里面 点击确定
    handleBtn() {
      this.dialog = false;
      // 通过 this.id 为空来判断 添加 || 修改
      if (this.id == "") {
        this.handleAdd();
      } else {
        this.handlePut();
      }
    },
    // 添加栏目函数
    handleAdd() {
      let params = {
        title: this.title,
        describe: this.describe,
        status: this.status,
        permission: this.marks.join(","),
      };
      roles_add(params).then((res) => {
        if (res) {
          this.handleData();
          this.$message({ type: "success", message: res.msg, duration: 1500 });
        }
      });
    },
    // 修改栏目函数
    handlePut() {
      let params = {
        title: this.title,
        describe: this.describe,
        status: this.status,
        permission: this.marks.join(","),
      };
      roles_put(this.id, params).then((res) => {
        if (res) {
          this.handleData();
          this.$message({ type: "success", message: res.msg, duration: 1500 });
        }
      });
    },
    // 修改状态
    handleStatus(row) {
      let params = {
        status: row.status,
      };
      roles_put(row.role_id, params).then((res) => {
        if (res) {
          this.handleData();
          this.$message({ type: "success", message: res.msg, duration: 1500 });
        }
      });
    },
    // 点击删除
    handleDel(it) {
      this.$confirm(`此操作将删除 ${it.title} 权限, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          roles_del(it.role_id).then((res) => {
            this.$message({ type: "success", message: res.msg });
            this.handleData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 监听 table 选中事件，获取选中数据的id
    handleChecked(rows) {
      rows.forEach((e) => {
        this.ids.push(e.role_id);
      });
    },
    // 批量操作  1 启用 2 禁用 3 删除
    handleBatch(index) {
      if (this.ids.length == 0) {
        this.$message({
          type: "error",
          message: "请至少选中一条数据进行批量操作哦",
        });
        return false;
      }
      if (index == 1) {
        let params = {
          status: 1,
        };
        roles_put(this.ids, params).then((res) => {
          if (res) {
            this.handleData();
            this.$message({
              type: "success",
              message: res.msg,
              duration: 1500,
            });
          }
        });
      } else if (index == 2) {
        let params = {
          status: 0,
        };
        roles_put(this.ids, params).then((res) => {
          if (res) {
            this.handleData();
            this.$message({
              type: "success",
              message: res.msg,
              duration: 1500,
            });
          }
        });
      } else if (index == 3) {
        this.$confirm(`此操作将删除所有选中的角色, 是否继续?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "error",
        })
          .then(() => {
            roles_del(this.ids).then((res) => {
              this.$message({ type: "success", message: res.msg });
              this.handleData();
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    handleMarks() {
      console.log(this.marks);
    },
  },
  created() {
    this.handleData();
  },
  activated() {
    this.handleData();
  },
};
</script>

<style lang="less" scoped>
section {
  .top-btn {
    width: 100px;
    margin-right: 15px;
  }
  .line-item {
    margin-bottom: 20px;
  }
  .input-left {
    height: 40px;
    line-height: 40px;
  }
}
</style>